import Vue from 'vue'
import wx from 'weixin-js-sdk'
import Router from 'vue-router'
import querystring from 'querystring'
import store from '../store'
// 活动页
import Api from '../utils/api';
import LocalStore from '../utils/localStore';


// 底部4大tab
import Home from '@/components/Home/Home.vue'
import Classify from '@/components/Classify/Classify.vue'
import Activity from '@/components/Activity/Activity.vue'
import ShoppCart from '@/components/ShoppCart/ShoppCart.vue'
import UserCenter from '@/components/UserCenter/UserCenter.vue'

// 详情 支付 收件地址 添加地址
import Detail from '@/components/Detail/Detail.vue'
import CreateOrder from '@/components/CreateOrder/CreateOrder.vue'
import ShippingAddress from '@/components/ShippingAddress/ShippingAddress.vue'
import AddAddress from '@/components/AddAddress/AddAddress.vue'

// 首页搜索页面
import HomeSearch from '@/components/HomeSearch/HomeSearch.vue'

import Pay from '@/components/Pay/Pay.vue'

// 订单 全部 待付款 待发货 待收货 退款/售后  订单追踪  订单详情// 6个页面
import OrderList from '@/components/OrderList/all.vue'
import CourierInfo from '@/components/OrderList/CourierInfo.vue'
import OrderDetail from '@/components/OrderList/OrderDetail.vue'
import NotData from '@/components/NoData/NoData.vue';

// 我的酒币
import WineMoney from '@/components/UserCenter/wineMoney/wineMoney.vue'
// 我的酒币→规则
import WineMoneyRules from '@/components/UserCenter/wineMoneyRules/wineMoneyRules.vue'
// 我的酒币→明细
import WineMoneyDetail from '@/components/UserCenter/wineMoneyDetail/wineMoneyDetail.vue'
// 夺酒记录
import TakeWine from '@/components/UserCenter/takeWine/takeWine.vue'
// 我的拼团
import SpellGroup from '@/components/UserCenter/spellGroup/spellGroup.vue'
// 添加优惠券
import AddCoupon from '@/components/UserCenter/addCoupon/addCoupon.vue'
import CollectCoupon from '@/components/UserCenter/addCoupon/collectCoupon.vue'
import bindMobileNumber from '@/components/UserCenter/bindMobileNumber.vue'
// 优惠券
import CouponList from '@/components/UserCenter/couponList/couponList.vue'
import CouponDetail from '@/components/UserCenter/couponList/coupon.vue'
// 中奖记录
import Winning from '@/components/UserCenter/winning/winning.vue'
// 我的收藏
import CollectList from '@/components/UserCenter/collectList/collectList.vue'
import invite from '@/components/UserCenter/invite/invite.vue'
import prize from '@/components/UserCenter/invite/prize.vue'
import inviteChallenge from '@/components/UserCenter/invite/inviteChallenge.vue'
// 关于我们
import About from '@/components/UserCenter/about/about.vue'
import WechatTest from '@/components/Wechat/Test.vue'

// 天天特价
import HomeTopNav from '@/components/HomeTopNav/HomeTopNav.vue';

// 签到
import HomeSignIn from '@/components/HomeSignIn/HomeSignIn.vue';

import Login from '@/components/Login/Login.vue';
import smsLogin from '@/components/Login/smsLogin.vue';

// 一元夺酒
import HomeTakeWine from '@/components/HomeTakeWine/HomeTakeWine.vue';

// 优惠券
import HomeCoupon from '@/components/HomeCoupon/HomeCoupon.vue';

// 首页 拼团列表
import HomeSpellGroup from '@/components/HomeSpellGroup/HomeSpellGroup.vue';

// 夺酒详情页面
import TakeWineDetail from '@/components/TakeWineDetail/TakeWineDetail.vue';

// 搜索页面
import Search from '@/components/Search/Search.vue';

// 我的拼团详情
import SpellGroupDetail from '@/components/UserCenter/spellGroup/Detail/Detail.vue'

// 我的拼团 订单详情
import SpellGroupOrderDetail from '@/components/UserCenter/spellGroup/OrderDetail/OrderDetail.vue'

// 消息页面
import Information from '@/components/UserCenter/Information/Information.vue'

// 我的页面 设置
import setUp from '@/components/userCenter/SetUp/SetUp.vue';

// 修改密码
import ChangPassword from '@/components/UserCenter/changPassword/changPassword.vue'

// 计算公式
import Formula from '@/components/UserCenter/takeWine/formula.vue'

// 中奖详情
import winningDetail from '@/components/UserCenter/winning/winningDetail.vue'

// 下载页面
import DownLoad from '@/components/DownLoad/DownLoadDetail.vue'

// 退款售后详情
import RefundDetail from '@/components/OrderList/RefundDetail.vue'

import Shipment from '@/components/OrderList/Shipment.vue'

// 使用优惠券后跳转商品推荐页面
import Recommend from '@/components/Recommend/Recommend.vue'



Vue.use(Router)
let routes = [{
        path: '/home',
        name: 'home',
        component: Home,
        meta: { keepAlive: true }
    }, {
        path: '/noshop',
        name: 'noshop',
        component: NotData,
        meta: { keepAlive: true }
    }, {
        path: '/wechat/test',
        name: 'WechatTest',
        component: WechatTest,
        meta: { keepAlive: true }
    }, {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { keepAlive: true }
    }, {
        path: '/smsLogin',
        name: 'smsLogin',
        component: smsLogin,
        meta: { keepAlive: true }
    }, {
        path: '/activity',
        name: 'activity',
        component: Activity,
        meta: { keepAlive: true }
    }, {
        path: '/classify',
        name: 'classify',
        component: Classify,
        meta: { keepAlive: true }
    }, {
        path: '/shoppCart',
        name: 'shoppCart',
        component: ShoppCart,
        meta: { keepAlive: true }
    }, {
        path: '/userCenter',
        name: 'userCenter',
        component: UserCenter,
        meta: { keepAlive: true }
    }, {
        path: '/search/:keyworld',
        name: 'search',
        component: Search,
        meta: { keepAlive: false }
    }, {
        path: '/downLoad',
        name: 'downLoad',
        component: DownLoad,
        meta: { keepAlive: false }
    },

    {
        path: '/home/signIn/:title',
        name: 'signIn',
        component: HomeSignIn,
        meta: { keepAlive: true }
    }, {
        path: '/home/takeWine/:title',
        name: 'takeWine',
        component: HomeTakeWine,
        meta: { keepAlive: true }
    }, , {
        path: '/home/takeWineDetail/:id',
        name: 'takeWineDetail',
        component: TakeWineDetail,
        meta: { keepAlive: true }
    }, {
        path: '/home/coupon/:title',
        name: 'coupon',
        component: HomeCoupon,
        meta: { keepAlive: true }
    }, {
        path: '/Home/spellGroup/:title',
        name: 'homeSpellGroup',
        component: HomeSpellGroup,
        meta: { keepAlive: true }
    },
    {
        path: '/Detail/:id',
        name: 'detail',
        component: Detail,
        meta: { keepAlive: false }
    }, {
        path: '/createOrder',
        name: 'createOrder',
        component: CreateOrder,
        meta: { keepAlive: false }
    }, {
        path: '/shippingAddress',
        name: 'shippingAddress',
        component: ShippingAddress,
        meta: { keepAlive: true }
    }, {
        path: '/AddAddress/:pathName',
        name: 'AddAddress',
        component: AddAddress,
        meta: { keepAlive: false }
    }, {
        path: '/homeSearch',
        name: 'homeSearch',
        component: HomeSearch,
        meta: { keepAlive: false }
    }, {
        path: '/pay',
        name: 'pay',
        component: Pay,
        meta: { keepAlive: false }
    },

    {
        path: '/orderList/:pathName',
        name: 'orderList',
        component: OrderList,
        meta: { keepAlive: true }
    },
    {
        path: '/orderList/RefundDetail/:id',
        name: 'RefundDetail',
        component: RefundDetail,
        meta: { keepAlive: false }
    },

    {
        path: '/orderList/courierInfo/:tid',
        name: 'courierInfo',
        component: CourierInfo,
        meta: { keepAlive: false }
    }, {
        path: '/orderList/orderDetail/:tid',
        name: 'orderDetail',
        component: OrderDetail,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/wineMoney',
        name: 'wineMoney',
        component: WineMoney,
        meta: { keepAlive: true }
    }, {
        path: '/userCenter/takeWine',
        name: 'userCenterTakeWine',
        component: TakeWine,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/takeWine/formula/:rob_id',
        name: 'formula',
        component: Formula,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/spellGroup',
        name: 'spellGroup',
        component: SpellGroup,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/spellGroup/detail/:group_id/:groupbuy_id',
        name: 'spellGroupDetail',
        component: SpellGroupDetail,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/spellGroup/orderDetail/:tid',
        name: 'spellGroupOrderDetail',
        component: SpellGroupOrderDetail,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/couponList',
        name: 'couponList',
        component: CouponList,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/coupon/:id',
        name: 'couponDetail',
        component: CouponDetail,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/winning',
        name: 'winning',
        component: Winning,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/winning/detail/:rob_id',
        name: 'winningDetail',
        component: winningDetail,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/invite',
        name: 'invite',
        component: invite,
        meta: { keepAlive: true }
    }, {
        path: '/userCenter/prize',
        name: 'prize',
        component: prize,
        meta: { keepAlive: true }
    }, {
        path: '/invite-challenge',
        name: 'invite-challenge',
        component: inviteChallenge,
        meta: { keepAlive: true }
    }, {
        path: '/userCenter/collectList',
        name: 'collectList',
        component: CollectList,
        meta: { keepAlive: true }
    }, {
        path: '/userCenter/addCoupon',
        name: 'addCoupon',
        component: AddCoupon,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/collectCoupon/:id',
        name: 'collectCoupon',
        component: CollectCoupon,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/shipment',
        name: 'shipment',
        component: Shipment,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/bindMobileNumber',
        name: 'bindMobileNumber',
        component: bindMobileNumber,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/about',
        name: 'about',
        component: About,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/information',
        name: 'information',
        component: Information,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/changPassword',
        name: 'changPassword',
        component: ChangPassword,
        meta: { keepAlive: false }
    }, {
        path: '/userCenter/setUp',
        name: 'setUp',
        component: setUp,
        meta: { keepAlive: false }
    },
    {
        path: '/userCenter/wineMoney/rules',
        name: 'wineMoneyRules',
        component: WineMoneyRules,
        meta: { keepAlive: false }
    },
    {
        path: '/userCenter/wineMoney/detail',
        name: 'wineMoneyDetail',
        component: WineMoneyDetail,
        meta: { keepAlive: false }
    },
    {
        path: '/homeTopNav/:lable_id/:modeltype/:widgets_type',
        name: 'homeTopNav',
        component: HomeTopNav,
        meta: { keepAlive: true }
    },
    {
        path: '/recommend',
        name: 'recommend',
        component: Recommend,
        meta: { keepAlive: false }
    },
    {
        path: '*',
        redirect: {
            name: 'home'
        },
        meta: { keepAlive: true }
    }
];

const router = new Router({
    routes
});

function initShopInfo() {
    // check shop info in store
    // if exist, next()
    // else check shop info in local storage
    // if exist, save to store and next
    // else load shop info by cname from api
    return Promise.resolve()
        .then(() => {
            if (store.state.shopInfo._id) {
                return store.state.shopInfo
            } else {
                const shopInfo = LocalStore.getShop()
                if (false && shopInfo) {
                    store.commit('updateShopInfo', shopInfo)
                    return shopInfo
                } else {
                    let cname = location.hostname
                    if (cname.endsWith('.localhost')) {
                        cname = cname.substr(0, cname.length - '.localhost'.length)
                    }
                    return Api.getShopInfoByCName(cname)
                        .then((res) => {
                            LocalStore.setShop(res.data)
                            store.commit('updateShopInfo', res.data)
                            return res.data
                        })
                        .catch((e) => {
                            if (e.response) {
                                // console.log(e.response.data.message)
                            }
                            return Promise.reject(e.response.data)
                        })
                }

            }
        })
}

function cleanLogin() {
    LocalStore.removeToken()
    LocalStore.removeUser()
    store.commit('updateUserInfo', null)
}

function redirectWeChatLogin() {
    window.location.href = process.env.API_ROOT + '/wechat/authorize?shopId='+store.state.shopInfo._id+'&shopUrl=' + location.origin;
}

const isWechat = navigator.userAgent.toLowerCase().indexOf('micromessenger') >= 0
const noWechatList = ['/noshop', '/pay'] // 不需要用户信息
const whiteList = ['/login', '/smsLogin']// 不重定向登录白名单

let wxReady = false
let shop = {}

router.beforeEach((to, from, next) => {
    initShopInfo()
    .then((shopInfo) => {
        shop = shopInfo
        Api.wxConfig({
            shopId: shopInfo._id,
            shopUrl: location.href.split('#')[0]
        })
            .then((resp) => {
                // console.log('wxconfig', resp)
                wx.config({
                    debug: false,
                    appId: resp.data.appId,
                    timestamp: resp.data.timestamp,
                    nonceStr: resp.data.noncestr,
                    signature: resp.data.signature,
                    jsApiList: [
                        'chooseImage',
                        'uploadImage',
                        'chooseWXPay',
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage'
                    ]
                });
                wx.ready(function (res) {
                    wxReady = true
                    // console.log('wxready', res)
                })
            })
            console.log(to.path, whiteList)
        if (noWechatList.indexOf(to.path) >= 0) {
            next()
        } else {
            const queryParse = querystring.parse(location.search.substr(1));
            if (queryParse.jwtToken) {
                // 如果URL信息中包含token，处理token并刷新
                LocalStore.setToken(queryParse.jwtToken)
                LocalStore.removeUser()
                window.location.href = location.origin
            } else if (to.path !== '/' && to.path[to.path.length - 1] === '/') {
                // 如果URL以/结尾，去除/
                next({path: to.path.substr(0, to.path.length - 1), replace: true})
            } else if (whiteList.indexOf(to.path) >= 0) { // 在免登录白名单，直接进入
                // 如果URL在免登录白名单中，跳过验证
                next()
            } else {
                // check user info in store
                // if exist, next()
                // else check user info in local storage
                // if exist, save to store and next
                // else check jwt in local storage
                // if exist, load user info from api
                // else login
                if (store.state.userInfo && store.state.userInfo._id) {
                    Api.getCartCount()
                    next();
                } else {
                    const jwtToken = LocalStore.getToken()
                    const user = LocalStore.getUser()
                    if (jwtToken && user && user._id) {
                        store.commit('updateUserInfo', user)
                        Api.getCartCount()
                        next();
                    } else if (jwtToken) {
                        return Api.getUserInfo()
                            .then(res => {
                                LocalStore.setUser(res.data)
                                store.commit('updateUserInfo', res.data)
                                Api.getCartCount()
                                next();
                            })
                            .catch(() => {
                                next();
                                cleanLogin()
                                if (isWechat) {
                                    redirectWeChatLogin()
                                } else {
                                    next({path: '/smsLogin', query: {fullPath: to.fullPath}, replace: true})
                                }
                            })
                    } else {
                        next();
                        cleanLogin()
                        if (isWechat) {
                            redirectWeChatLogin()
                        } else {
                            next({path: '/smsLogin', query: {fullPath: to.fullPath}, replace: true})
                        }
                    }
                }
            }

        }
    })
    .catch((e) => {
        next('/noshop')
    })
});

router.afterEach((to, form) => {
    // if (wxReady) {
    //     wx.onMenuShareAppMessage({
    //         title: shop.name,
    //         desc: shop.name,
    //         link: location.origin + '/?' + location.search.substr(1) + '#' + to.fullPath,
    //         imgUrl: shop.logo,
    //         success: function () {
    //         }
    //     });
    // }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js